const getUserProfileQuery = /* GraphQL */ `
  query GetUserProfile($webUserGuid: String = null) {
    userProfile(webUserGuid: $webUserGuid) {
      emailAddress
      firstName
      lastName
      userGuid
      userName
      isRegistered
      sopCustomerId
      isSignedUpForEmails
      zipCode
      isInternational
      isCustomerInternal
      isSpecialPriceEligible
      isLoyaltyBetaUser
      isLoyaltyRegisteredUser
      isBrowsingCustomerAuthorized
    }
  }
`

export default getUserProfileQuery
